import { combineReducers } from "redux";

import { companyDetails } from "./reducer.company"
const companyReducers = combineReducers({
  companyDetails
})
export default companyReducers;
